module.exports = __webpack_public_path__ + "7e7b4ffb7b4bf57b8632d5db71a1bf72.svg";